import { all } from 'redux-saga/effects';
import loginSaga from './loginSaga';
import registrationSaga from './registrationSaga';
import userSaga from './userSaga';
import teamSaga from './teamSaga';
import visualSaga from './visualSaga';
import currentContestSaga from './currentContestSaga';
import allContestsSaga from './allContestsSaga';
import questionSaga from './questionSaga';
import pointTotalSaga from './pointTotalSaga';

// rootSaga is the primary saga.
// It bundles up all of the other sagas so our project can use them.
// This is imported in index.js as rootSaga

// some sagas trigger other sagas, as an example
// the registration triggers a login
// and login triggers setting the user
export default function* rootSaga() {
  yield all([
    loginSaga(),
    registrationSaga(),
    userSaga(),
    teamSaga(),
    visualSaga(),
    currentContestSaga(),
    allContestsSaga(),
    questionSaga(),
    pointTotalSaga(),
  ]);
}
